import { render, staticRenderFns } from "./ConfigCidadeSobreEditar.vue?vue&type=template&id=016ba301&scoped=true&"
import script from "./ConfigCidadeSobreEditar.vue?vue&type=script&lang=js&"
export * from "./ConfigCidadeSobreEditar.vue?vue&type=script&lang=js&"
import style0 from "./ConfigCidadeSobreEditar.vue?vue&type=style&index=0&id=016ba301&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016ba301",
  null
  
)

export default component.exports